import React from 'react';
import { resolveImage } from '../../lib/images';

export const EquipmentInfo = ({ equipment }) => {
  return (
    <div>
      <img
        src={resolveImage(equipment.image_url) || 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800'}
        alt={equipment.name}
        className="w-full h-96 object-cover rounded-lg shadow-xl mb-6 border border-[#B8860B]/30"
        data-testid="equipment-detail-image"
      />
      <div className="bg-[#0B132B] border border-[#B8860B]/30 rounded-lg p-6 shadow-lg">
        <h1 className="text-3xl font-bold text-[#F4F1EA] mb-2" data-testid="equipment-name">
          {equipment.name}
        </h1>
        <p className="text-[#B8860B] font-semibold mb-4">{equipment.category}</p>
        <p className="text-[#F4F1EA]/80 mb-6">{equipment.description}</p>

        <div className="border-t border-[#B8860B]/20 pt-4">
          <h3 className="font-bold text-[#F4F1EA] mb-2">Specifications:</h3>
          <p className="text-[#F4F1EA]/70">{equipment.specifications}</p>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-6">
          <div className="bg-[#050814] border border-[#B8860B]/20 p-4 rounded-lg">
            <p className="text-sm text-[#F4F1EA]/70 mb-1">Daily Rate</p>
            <p className="text-2xl font-bold text-[#B8860B]">${equipment.daily_rate}</p>
          </div>
          {equipment.weekly_rate > 0 && (
            <div className="bg-[#050814] border border-[#B8860B]/20 p-4 rounded-lg">
              <p className="text-sm text-[#F4F1EA]/70 mb-1">Weekly Rate (7 days)</p>
              <p className="text-2xl font-bold text-[#B8860B]">${equipment.weekly_rate}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
